<template>
  <div class="modal fade" :id="''+id" data-bs-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t('access.configAccess.shareConfig') }}</h5>
          <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal" aria-label="Close">
              <span class="svg-icon svg-icon-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                        fill="currentColor"/>
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                        fill="currentColor"/>
                  </svg>
              </span>
          </div>
        </div>
        <div class="modal-body scroll-y" style="max-height: 75vh;">
          <div>
            <RequiredText :text="$t('access.configAccess.transferWarning')" />

          </div>
          <DoorsTree
              :perimeters="formatedPerimeters"
              v-model="formData.to_id"
              :can-edit="false"
          />
        </div>
        <div class="modal-footer">
          <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.close" @click.prevent="closeModal"></Button>
          <Button btn-class="btn-sm" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoading" @click.prevent="submitForm"></Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, defineProps, watch } from 'vue'
import {useStore} from "vuex";
import RequiredText from "@/components/RequiredText"
import Button from "@/components/Button.vue"
import Card from "@/components/Card.vue";
import SwitchInput from "@/components/SwitchInput.vue";
import AccessMethodCard from "@/Modules/Access/views/Config/components/AccessMethodCard.vue";
import {useLocales} from "@/composables/locales";
import AccessHours from "@/Modules/Access/views/Config/components/AccessHours.vue";
import DoorsTree from "@/Modules/Access/views/Config/components/DoorsTree.vue";

const { locale } = useLocales()

const store = useStore()

const props = defineProps({
  data: {
    type: Object,
    default: {
      id: '',
      to_id: '',
      type: '',
    },
    required: true
  },
  id: {
    type: String,
    required: true
  },
  parent: {
    type: String,
    required: false
  }
})

const emits = defineEmits(['callback'])

const formData = ref(props.data)
const isLoading = ref(false)


const perimeters = computed(() => store.getters['perimeters/getMainPerimeters'])
const formatedPerimeters = computed(() => {
  if(!perimeters.value.length) return []
  return formatTreeData(perimeters.value)
})

watch(() => props.data, () => {
  formData.value = {...props.data}
})

function closeModal(){
  if(props.parent){
    $('#'+props.parent).modal('toggle')
  }
  $('#'+props.id).modal('toggle')
  formData.value = {
    from_id: '',
    to_id: '',
    user_id: '',
    type: '',
  }
}

function formatTreeData(data, isStat = true) {
  let tree = []


  data.forEach(perimeter => {
    let node = {
      id: perimeter.id,
      name: perimeter.name,
      accessMethods: perimeter.accessMethods,
      children: [],
      isStat,
      isDoor: !perimeter?.doors && !perimeter?.children
    }

    if (perimeter.children && perimeter.children?.length) {
      const formattedChildren = formatTreeData(perimeter.children, false)
      node.children.push(...formattedChildren)
    }

    if (perimeter.doors && perimeter.doors?.length) {
      const formattedDoors = formatTreeData(perimeter.doors, false)
      node.children.push(...formattedDoors)
    }

    tree.push(node)
  })

  return tree
}
function findNodeById(tree, id) {
  for (const node of tree) {
    if (node.id === id) {
      return node
    }

    if (node.children && node.children.length) {
      const found = findNodeById(node.children, id)
      if (found) {
        return found
      }
    }
  }

  return null
}
function submitForm(){
  isLoading.value = true
  formData.value.type = findNodeById(formatedPerimeters.value, formData.value.to_id)?.isDoor ? 'door' : 'perimeter'
  store.dispatch('access/shareConfig', formData.value)
      .then((response) => {
        emits('callback')
        closeModal()
        window.toastr['success'](i18n.global.t('notification.method_updated'))
      })
      .catch()
      .finally(() => isLoading.value = false)
}



</script>